// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__3cVv6","headerCell":"Table_headerCell__1Cap5","rowHeader":"Table_rowHeader__2uVOP","rowBody":"Table_rowBody__19rUY","bodyCell":"Table_bodyCell__36CTa"};